import React from "react";
import { FaBriefcase } from "react-icons/fa";
import { IconBaseProps, IconType } from "react-icons";

interface PageHeaderProps {
  title: string;
  icon?: IconType;
  tabs?: string[];
  activeTab?: string;
  onTabClick?: (tab: string) => void;
  rightContent?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  icon,
  tabs = [],
  activeTab,
  onTabClick,
  rightContent,
}) => {
  const IconToRender = icon ?? FaBriefcase;

  return (
    <div className="flex flex-col justify-between gap-4 mb-6 md:flex-row md:items-center">
      {/* Left: Title & Tabs */}
      <div>
        <div className="flex items-center gap-2 mb-2 text-xl font-semibold text-gray-700">
          <div className="text-gray-600">
            {React.createElement(
              IconToRender as React.ComponentType<IconBaseProps>,
            )}
          </div>
          <h1>{title}</h1>
        </div>

        {tabs.length > 0 && (
          <div className="flex gap-2">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => onTabClick?.(tab)}
                className={`px-4 py-1.5 rounded text-sm font-semibold ${
                  activeTab === tab
                    ? "bg-black text-white"
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
              >
                {tab}
                {tab === "Cancelled" && (
                  <span className="ml-1 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                    2
                  </span>
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Right controls */}
      <div className="flex items-center gap-3">{rightContent}</div>
    </div>
  );
};

export default PageHeader;
